"use client";
import clsx from "clsx";

import useSortModal from "@/lib/hooks/plpUseSortModal";
import { useQueryParams } from "@frend-digital/ui/next";

import { DepictSort } from "@/lib/hooks/useProductFilter/types";
import { startTransition, useOptimistic } from "react";
import styles from "./sort-modal.module.css";

type SortOption = {
  field: string;
  order: string;
  meta: {
    title: string;
  };
};

export const queryParamOptions = {
  shallow: false,
  replace: true,
} as const;

const SortModal = ({ sortOrder }: { sortOrder: DepictSort[] }) => {
  const { isOpen, closeModal, ref } = useSortModal();

  const searchParams = useQueryParams(queryParamOptions);
  const [optimisticSort, setOptimisticSort] = useOptimistic(
    searchParams.get("sort"),
  );

  const onChange = (value: DepictSort) => {
    startTransition(() => {
      searchParams.set("sort", value.field + "_" + value.order);
    });
  };

  return (
    <>
      <div className={clsx(styles.modal, isOpen && styles.active)} ref={ref}>
        {isOpen && (
          <div className={styles.modal__content}>
            <nav>
              <div className={styles.modal__header}>
                <p className={styles.sort_by}>SORT BY</p>
                <button onClick={closeModal}>X</button>
              </div>
              <div className={styles["sort-options"]}>
                {sortOrder?.map((option, index: number) => {
                  const isActive =
                    searchParams
                      .get("sort")
                      ?.replace(`_${option.order}`, "") === option.field;
                  return (
                    <button
                      key={index}
                      className={clsx(
                        styles["sort-option"],
                        isActive && styles.active,
                      )}
                      disabled={isActive}
                      onClick={() => onChange(option)}
                    >
                      {option.meta.title}
                    </button>
                  );
                })}
              </div>
            </nav>
          </div>
        )}
      </div>

      <div
        className={clsx(styles.overlay, isOpen && styles.active)}
        onClick={closeModal}
      ></div>
    </>
  );
};

export default SortModal;
